import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import BookCard from "@/components/BookCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/wishlist");
        setItems(data.items || []);
      } catch (e) { console.error(e); }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="wishlist-page">
      <h1 className="font-display text-3xl md:text-5xl font-black border-b-2 border-[#09090b] pb-4 mb-6">My Wishlist</h1>
      {loading ? (
        <div>Loading…</div>
      ) : items.length === 0 ? (
        <div className="border-2 border-dashed border-border p-16 text-center">
          <Heart className="w-14 h-14 mx-auto mb-3 text-[#a1a1aa]" />
          <div className="font-display text-2xl font-black mb-2">No saved books yet</div>
          <p className="text-sm text-[#52525b] mb-4">Tap the heart on any book to save it here.</p>
          <Link to="/books" className="inline-block bg-[#09090b] text-white font-bold px-6 py-3">Browse Books</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((b) => <BookCard key={b.id} book={b} />)}
        </div>
      )}
    </div>
  );
}
